/*
    Business Logic for member form with questionnaire option selected
*/
define('shared/initializer/form/adapters/mixins/MemberCreationQuestionnaireAfterCreatable',[
    '$',
    '../../constants', 
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/remote/lead/enrolmentSurvey/consume'
], function (
    $,
    constants,
    RSVP,
    state,
    FormDataDispatcher,
    ConsumeEnrolmentSurvey
) {
    'use strict';

    var mustHaveFields = ['first_name', 'last_name', 'email', 'lead_id'];

    function createHiddenFields() {
        var me = this;
        return RSVP.resolve()
            .then(function(){
                var dispatcher = new FormDataDispatcher(me.$form);
                var items = {};
                var itemName;

                for(var l = mustHaveFields.length; l--;) {
                    itemName = mustHaveFields[l];
                    items[itemName] = {
                        sources: [
                            {type: 'state', key: 'form.' + itemName, allowUndefined: true}
                        ],
                        targets: [
                            {type: 'form', key: itemName.replace(/_/, ''), autoCreation: true}
                        ],
                        allowUndefined: true
                    };
                }

                items.partner_code = {
                    sources: [
                        {type: 'state', key: 'session.partner_code', allowUndefined: true},
                        {retrieve: function(){return RSVP.resolve('None');}}
                    ],
                    targets: [
                        {type: 'form', key: 'member.partnercode', autoCreation: true}
                    ],
                    allowUndefined: true
                };

                return dispatcher.dispatch({
                    items: items,
                    timeout: 1 * 1000
                });
            });
    }

    function Ctor() { 
        var me = this;
        if (!me.options.memberQuestionnaire) {
            return;
        }

        me.options.checkoutFlowControl = {
            enable: false
        };

        me.options.redirectable = {
            enable: false
        };

        if (
            me.options.action.aftersubmit.target === 'open' || 
            me.options.action.aftersubmit.target === 'preenrolment-handler'
        ) {
            me.options.omnitureTriggerable = {
                enable: true
            };
        }
    }

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        if (!this.options.memberQuestionnaire) {
            return RSVP.resolve();
        }
        return RSVP.resolve()
            .then(function(){
                return createHiddenFields.call(me);
            });
    };

    function getFormElementValue(elementName) {
        var me = this;
        var $el = me.$form.find('[name="' + elementName + '"]');    
        return $el.val();
    }

    Ctor.prototype.doBeforeSubmit = function() {
        var me = this;

        if (!me.options.memberQuestionnaire) {
            return RSVP.resolve();
        }

        var enrolmentOptions = {
            leadId: getFormElementValue.call(me, constants.FIELD.LeadId),
            academicQualifications: getFormElementValue.call(me, constants.FIELD.AcademicQualifications),
            studyFrequency: getFormElementValue.call(me, constants.FIELD.StudyFrequency)
        };

        return ConsumeEnrolmentSurvey(enrolmentOptions);


    };

    return Ctor;
});
